import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import routerObj from '@/router/common'
Vue.use(Vuex)
let host = window.location.protocol
const store = new Vuex.Store({
  state: {
    linkData: [
      {
        path: '/A01_B01_CA02/account',
        name: '账户设定'
      }
    ],
    isCollapse: true, // 菜单开关变量
    menu: [{ name: '工作桌面', index: '0-0-0', href: host + '/A01_B04_CA03/desk', ob: {} }], // 标签原始数组
    // menu: [{name: '工作桌面', index: '0-0-0', href: 'http://localhost:8080/desk'}], // 标签原始数组
    activeTab: '0-0-0', // 默认选中标签
    arrowActive: false, // 标签滚动默认状态
    token: localStorage.getItem('sessionid'),
    account: JSON.parse(localStorage.getItem('account')),
    activeName: 'index',
    loginFlag: false, // 默认不弹出登录框
    invite_code: '',
    registerType: 'PhoneRegister',
    powerAccount: ''
  },
  mutations: {
    updateMenu (state, data) {
      let menu = state.menu.find(item => item.index === state.activeTab)
      menu.name = data.name
    },
    changePowerAccount(state, data) {
      state.powerAccount = data
    },
    openSidebar(state, data) { // 菜单展开开关
      state.isCollapse = data
    },
    addMenu(state, data) { // 添加、切换标签
      let index = state.menu.findIndex(item => item.index === data.index)
      if (index < 0) {
        state.menu.push(data)
      } else {
        state.menu.splice(index, 1)
        state.menu.splice(index, 0, data)
      }
      state.activeTab = data.index
    },
    delMenu(state, index) { // 删除标签
      state.menu.splice(index, 1)
      state.activeTab = state.menu[state.menu.length - 1].index
      console.log(state.menu)
    },
    changeArrowActive(state, type) { // 滚动切换隐藏与显现
      state.arrowActive = type
    },
    SET_TOKEN(state, token) {
      state.token = token
    },
    LOGIN(state, type) {
      state.activeName = type
      state.aa = type
    },
    loginFlag(state, type) {
      state.loginFlag = type
    },
    REGISTERTYPE(state, type) {
      console.log(type)
      state.registerType = type
    },
    SET_ACCOUNT(state, data) {
      state.account = data
    },
    INVITE_CODE(state, data) {
      state.invite_code = data
    }
  },
  actions: {
    delMenuNasnyc(context, data) { // 异步触发删除标签，这里需要延迟，不然无法删除数组
      setTimeout(() => {
        console.log(data)
        let index = this.state.menu.findIndex(item => item.index === data.index)
        context.commit('delMenu', index)
      })
    },
    apiLogin(context, data) { // 访问接口登录
      context.commit('SET_TOKEN', data.data.session_id)
      context.commit('loginFlag', false)
      localStorage.setItem('sessionid', data.data.session_id)

      axios.post('/api/A01_B03_CA02/login/get-login-user-info').then(async res => {
        if (res.data.code === '000000') {
          context.commit('SET_ACCOUNT', res.data.data)
          localStorage.setItem('account', JSON.stringify(res.data.data))
          localStorage.setItem('IPAddress', data.address_ip)
          
          let user_info = {
            user_name: res.data.data.user_name || res.data.data.account,
            user_id: res.data.data.user_id
          }
          localStorage.setItem('mobileAccount', JSON.stringify(user_info))
          // let obj = {
          //   user_id: res.data.data.user_id,
          //   main_id: res.data.data.main_id,
          //   address_ip: data.address_ip,
          // }
          // await axios.post('/api/A01_B03_CA02/login/save-login-by-ip-log', obj)
          // window.location.href = window.location.protocol + "/A01_B04_CA01/layout"

          // try {
          //   await axios.post('/api/A01_B03_CA02/login/save-login-by-ip-log', obj)
          // } catch (error) {
          //   console.log(error);
          // } finally {
          //   window.location.href = window.location.protocol + "/A01_B04_CA01/layout"
          // }
          window.location.href = window.location.protocol + "/A01_B04_CA01/layout"
        }
      }).catch(err => {
        console.log(err)
      })
    },
    phoneLogin(context, data) { // 手机号登录
      context.commit('SET_TOKEN', data.data.session_id)
      context.commit('loginFlag', false)
      localStorage.setItem('sessionid', data.data.session_id)
      axios.post('/api/A01_B03_CA02/login/get-login-user-info').then(async res => {
        if (res.data.code === '000000') {
          context.commit('SET_ACCOUNT', res.data.data)
          localStorage.setItem('account', JSON.stringify(res.data.data))
          localStorage.setItem('IPAddress', data.address_ip)
          
          let user_info = {
            user_name: res.data.data.user_name || res.data.data.account,
            user_id: res.data.data.user_id
          }
          localStorage.setItem('mobileAccount', JSON.stringify(user_info))
          // window.location.href = window.location.protocol + "/A11_B04_CA00/EPC"
          window.location.href = window.location.protocol + "/A01_B04_CA01/layout"
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }

})

export default store



// WEBPACK FOOTER //
// ./src/store/A01/index.js